<template>
  <div id="footer">
    Copyright &copy; 2017-{{year}} 厦门泰博科技有限公司版权所有 备案：闽ICP备07041717号-1
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: '2018',
    }
  },
  mounted() {
    let myDate = new Date();
    this.year = myDate.getFullYear();
  }
}
</script>
<style lang="scss">
#footer {
  background-color: #eff2fa;
  position: fixed;
  bottom: 0px;
  line-height: 42px;
  text-align: center;
  height: 42px;
  width: 100%;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue